/**
 * Created by h3 on 2018-09-18.
 */
import {ILayerConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {CustomLayerScaleOptions, LayerScaleOption, RectLike} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IFruitsLayerConfig} from "./IFruitsLayerConfig";


export class FruitsLayerConfig {

    public static defaultLayerScaleOptions:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };

    public static customPlacement = {
        placement : {x : 0.5, y : 1},
    };

    public static BACKGROUND:ILayerConfig = {
        name : "background",
        customOptions : FruitsLayerConfig.customPlacement,
    };

    public static INTRO:ILayerConfig = {
        name : "introScreen",
        customOptions : FruitsLayerConfig.customPlacement
    };

    public static screenLayerScaleOptions:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.FIT_WINDOW
        }
    };

    private static mobilePortraitFrame:RectLike = {
        x : 271,
        y : -263,
        width : 738,
        height : 1246 + 238,
    };

    private static defaultFrame:RectLike = {
        x : 0,
        y : 0,
        width : 1280,
        height : 720,
    };

    public static deviceFrames:IDeviceDependentConfig<RectLike> = {
        desktop : {landscape : FruitsLayerConfig.defaultFrame},
        mobile : {
            landscape : FruitsLayerConfig.defaultFrame,
            portrait : FruitsLayerConfig.mobilePortraitFrame
        }
    };

    public static customFrame:CustomLayerScaleOptions = {
        frame : FruitsLayerConfig.deviceFrames
    };


    public static REEL_BACKGROUND:ILayerConfig = {
        name : "reelBackground",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static SYMBOLS:ILayerConfig = {name : "symbols", customOptions : FruitsLayerConfig.customFrame};
    public static LOGO:ILayerConfig = {name : "logo", customOptions : FruitsLayerConfig.customFrame};
    public static STICKY_SYMBOL:ILayerConfig = {name : "stickySymbol", customOptions : FruitsLayerConfig.customFrame};
    public static STICKY_PRESENTATIONS:ILayerConfig = {
        name : "stickyPresentations",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static REEL_ATTENTION:ILayerConfig = {name : "reelAttention", customOptions : FruitsLayerConfig.customFrame};
    public static BET_LINES:ILayerConfig = {name : "betLines", customOptions : FruitsLayerConfig.customFrame};
    public static WIN_PRESENTATIONS:ILayerConfig = {
        name : "winPresentations",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static STICKY_RESPIN_OVERLAY:ILayerConfig = {
        name : "stickyRespin",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static BIG_WIN:ILayerConfig = {name : "bigWin", customOptions : FruitsLayerConfig.customFrame};
    public static WIN_COUNT_UP:ILayerConfig = {name : "winCountUp", customOptions : FruitsLayerConfig.customFrame};

    public static BONUS_OVERLAY:ILayerConfig = {
        name : "bonusOverlay",
        scaleOption : LayerScaleOption.FIT_WINDOW,
        customOptions : FruitsLayerConfig.customFrame
    };
    public static BONUS_RIGHT_SIDE_OVERLAY:ILayerConfig = {
        name : "bonusRightSideOverlay",
        scaleOption : LayerScaleOption.FIT_WINDOW,
        customOptions : FruitsLayerConfig.customFrame
    };
    public static BONUS_GAME_PRE_INTRO:ILayerConfig = {
        name : "bonusGamePreIntro",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static BONUS_GAME_PRE_INTRO_SCATTERS:ILayerConfig = {
        name : "bonusGamePreIntroScatters",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static BONUS_GAME_INTRO:ILayerConfig = {
        name : "bonusGameIntro",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static BONUS_GAME_OUTRO:ILayerConfig = {
        name : "bonusGameOutro",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static FRUITS_PARTICLES:ILayerConfig = {
        name : "fruitsParticles",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static HIGH_ORDER_LAYER:ILayerConfig = {
        name : "highOrderLayer",
        customOptions : FruitsLayerConfig.customFrame
    };
    public static TWEAK_MODULE:ILayerConfig = {
        name : "tweakModule",
        scaleOption : LayerScaleOption.FIT_STAGE,
        customOptions : FruitsLayerConfig.customFrame
    };

    public static getConfig():IFruitsLayerConfig {
        return {
            BACKGROUND : FruitsLayerConfig.BACKGROUND,
            REEL_BACKGROUND : FruitsLayerConfig.REEL_BACKGROUND,
            SYMBOLS : FruitsLayerConfig.SYMBOLS,
            STICKY_RESPIN_OVERLAY : FruitsLayerConfig.STICKY_RESPIN_OVERLAY,
            LOGO : FruitsLayerConfig.LOGO,
            STICKY_SYMBOL : FruitsLayerConfig.STICKY_SYMBOL,
            STICKY_PRESENTATIONS : FruitsLayerConfig.STICKY_PRESENTATIONS,
            REEL_ATTENTION : FruitsLayerConfig.REEL_ATTENTION,
            BET_LINES : FruitsLayerConfig.BET_LINES,
            BONUS_OVERLAY : FruitsLayerConfig.BONUS_OVERLAY,
            BONUS_RIGHT_SIDE_OVERLAY : FruitsLayerConfig.BONUS_RIGHT_SIDE_OVERLAY,
            WIN_PRESENTATIONS : FruitsLayerConfig.WIN_PRESENTATIONS,
            BIG_WIN : FruitsLayerConfig.BIG_WIN,
            WIN_COUNT_UP : FruitsLayerConfig.WIN_COUNT_UP,
            BONUS_GAME_PRE_INTRO : FruitsLayerConfig.BONUS_GAME_PRE_INTRO,
            BONUS_GAME_PRE_INTRO_SCATTERS : FruitsLayerConfig.BONUS_GAME_PRE_INTRO_SCATTERS,
            BONUS_GAME_INTRO : FruitsLayerConfig.BONUS_GAME_INTRO,
            BONUS_GAME_OUTRO : FruitsLayerConfig.BONUS_GAME_OUTRO,
            FRUITS_PARTICLES : FruitsLayerConfig.FRUITS_PARTICLES,
            HIGH_ORDER_LAYER : FruitsLayerConfig.HIGH_ORDER_LAYER,
            INTRO : FruitsLayerConfig.INTRO,
            TWEAK_MODULE : FruitsLayerConfig.TWEAK_MODULE
        }
    }
}